import React from 'react';
import {IonButton, IonContent, IonPage, IonText} from "@ionic/react";

/**
 * Visible fallback for the top-level Sentry ErrorBoundary. A render crash is
 * reported to Sentry, but the user must still see something actionable rather
 * than a permanent blank white screen.
 */
const ErrorFallback: React.FC = () => {
    return (
        <IonPage>
            <IonContent className="ion-padding ion-text-center">
                <div style={{marginTop: "40%"}}>
                    <IonText>
                        <h2>Something went wrong</h2>
                        <p>The app hit an unexpected error. Please reload to continue.</p>
                    </IonText>
                    <IonButton onClick={() => window.location.reload()}>
                        Reload
                    </IonButton>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ErrorFallback;
